import { ChoiceGroup, IChoiceGroupProps } from '@fluentui/react/lib/ChoiceGroup';

export interface IPChoiceGroupProps extends IChoiceGroupProps {}

export const IPChoiceGroup = (props: IPChoiceGroupProps) => {
  return <ChoiceGroup {...props} />;
};
